import React from 'react';
import DashboardPage from '../components/DashboardPage';

export default function DashboardLayout({ onLogout }) {
  /*
   * Keep the dashboard shell mounted while the URL changes. Previously each
   * child route created a fresh DashboardPage, which repeated profile, scope,
   * overview and table requests on every navigation.
   */
  return <DashboardPage onLogout={onLogout} />;
}
